export default __webpack_public_path__ + "static/media/eSupport-not-selected.55150bb7.svg";